import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AdminProvider } from './contexts/AdminContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Branches from './pages/Branches';
import Products from './pages/Products';
import Delivery from './pages/Delivery';
import About from './pages/About';
import PrescriptionDrugs from './pages/PrescriptionDrugs';
import BloodGlucose from './pages/BloodGlucose';
import RapidDiagnostics from './pages/RapidDiagnostics';
import Surgical from './pages/Surgical';
import MedicalInstruments from './pages/MedicalInstruments';
import Laboratory from './pages/Laboratory';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProductManagement from './pages/admin/ProductManagement';
import CategoryManagement from './pages/admin/CategoryManagement';
import BranchManagement from './pages/admin/BranchManagement';

function App() {
  return (
    <AdminProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes (no Header/Footer) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products"
            element={
              <ProtectedRoute>
                <ProductManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/categories"
            element={
              <ProtectedRoute>
                <CategoryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/branches"
            element={
              <ProtectedRoute>
                <BranchManagement />
              </ProtectedRoute>
            }
          />

          {/* Public Routes (with Header/Footer) */}
          <Route
            path="/*"
            element={
              <div className="App">
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/branches" element={<Branches />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/prescription-drugs" element={<PrescriptionDrugs />} />
                    <Route path="/products/blood-glucose" element={<BloodGlucose />} />
                    <Route path="/products/rapid-diagnostics" element={<RapidDiagnostics />} />
                    <Route path="/products/surgical" element={<Surgical />} />
                    <Route path="/products/medical-instruments" element={<MedicalInstruments />} />
                    <Route path="/products/laboratory" element={<Laboratory />} />
                    <Route path="/delivery" element={<Delivery />} />
                    <Route path="/about" element={<About />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            }
          />
        </Routes>
      </Router>
    </AdminProvider>
  );
}

export default App;
